import { DecimalPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import {
  RdsIconComponent,
  RdsProgressSpinnerComponent,
} from '@rds/angular-components';

import { ChartDataService } from '@bookly/shared';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bsh-booking-stats',
  templateUrl: './booking-stats.component.html',
  styleUrl: './booking-stats.component.scss',
  imports: [
    RdsProgressSpinnerComponent,
    DecimalPipe,
    NgClass,
    RdsIconComponent,
  ],
})
export class BookingStatsComponent implements OnInit {
  readonly #chartDataService = inject(ChartDataService);
  protected readonly stats = this.#chartDataService.stats;
  protected readonly isLoading = this.#chartDataService.areStatsLoading;
  protected readonly weekday = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
  });

  ngOnInit(): void {
    this.#chartDataService.loadBookingStats().subscribe();
  }

  protected formatDuration(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const m = Math.round(minutes % 60);
    return `${h}h ${m}m`;
  }
}
